import React, { useState, useEffect, useRef } from "react";
import {
	Button,
	Checkbox,
	CheckboxGroup,
	Modal,
	Notification,
	SelectPicker,
	toaster,
} from "rsuite";
import { numberFormatter } from "../../utils";
import { CSVLink } from "react-csv";
// import { timelineOptions } from "../constants";
import { useDispatch } from "react-redux";
import {
	getIntoStockExportData,
	getSpaExportData,
	getTailExportData,
} from "../../queries/apiQueries";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { getTimelineOptions } from "../../config/constants";

const CategoryOverview = (props: any) => {
	const dispatch = useDispatch<any>();
	const {
		data,
		page,
		districtfilterOptions,
		selectedDistrictFilter,
		updateSelectedDistrictFilter,
		selectedFilters,
		selectedProjectType,
	} = props;

	const timelineOptions=getTimelineOptions()

	const [selectedSupplier, setSelectedSupplier] = useState(null);

	const [exportIntoStock, setExportIntoStoc] = useState([]);
	const exportIntoStockRef = useRef<any>(null);

	const [exportIntoStockSaving, setExportIntoStocSaving] = useState([]);
	const exportIntoStockSavingRef = useRef<any>(null);

	const [exportSPA, setExportSPA] = useState([]);
	const exportSPARef = useRef<any>(null);

	const [exportSPASaving, setExportSPASaving] = useState([]);
	const exportSPASavingRef = useRef<any>(null);

	const [selectedTailSupplierList, setSelectedTailSupplierList] =
		useState<any>([]);

	const [exportTailSupplier, setExportTailSupplier] = useState([]);
	const exportTailSupplierRef = useRef<any>(null);

	const csvHeaders = [
		{ label: "Supplier", key: "master_vendor_name" },
		{ label: "Spend ($)", key: "spend" },
		{ label: "NIA ($)", key: "niaEarnings" },
		{ label: "Gross Margin %", key: "grossMargin" },
	];

	const exportIntoStockSavingHeader = [
		{ label: "Graybar SKU ID", key: "material_material" },
		{ label: "Supplier Catalog #", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "SKU Description", key: "itemdesc" },
		{ label: "District", key: "district" },
		{ label: "Quantity", key: "volume" },
		{ label: "Into Stock Cost ($/Unit)", key: "intocost" },
		{ label: "Annual Spend", key: "annualSpend" },
	];

	const exportIntoStockHeader = [
		{ label: "Product Hierarchy", key: "PRODUCT_HIERARCHY_PRODH" },
		{ label: "Product Group Description", key: "PRODUCT_HIERARCHY_PRODH" },
		{ label: "Graybar SKU ID", key: "material_material" },
		{ label: "Supplier Catalog #", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "SKU Description", key: "itemdesc" },
		{ label: "Quantity", key: "volume" },
		{ label: "Estimated Qty. Range", key: "estimatedQtyRange" },
	];

	const exportSPAHeader = [
		{ label: "GBID", key: "material_material" },
		{ label: "Supplier Catalog #", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "SKU Description", key: "itemdesc" },
		{ label: "SPA Agreement ", key: "spa_agreement" },
		{ label: "Quote Number", key: "volume" },
		{ label: "District Name", key: "district" },
	];

	const exportSPASavingHeader = [
		{ label: "GBID", key: "material_material" },
		{ label: "Supplier Catalog #", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "SKU Description", key: "itemdesc" },
		{ label: "SPA Agreement ", key: "spa_agreement" },
		// { label: "Quote Number", key: "volume" },
		{ label: "District Name", key: "district" },
		{ label: "Annual Quantity", key: "volume" },
		{ label: "Into Stock Cost ($/Unit)", key: "intocost" },
		{ label: "Net Cost ($/Unit)", key: "netcost" },
		{ label: "Annual Spend", key: "annualSpend" },
	];

	const exportTailSupplierHeader = [
		{ label: "GBID", key: "material_material" },
		{ label: "Catalog #", key: "MANUFACTURER_PART_NO_MFRPN" },
		{ label: "OEM Name ", key: "master_vendor_name" },
		{ label: "SKU Description", key: "itemdesc" },
	];

	const [selectedTimeline, setSelectedTimeline] = useState(
		getTimelineOptions()[0]?.value
	);

	const [proposalModal, setProposalModal] = useState(false);
	const [proposalSupplierType, setProposalSupplierType] = useState<any>(null);
	const [tailSupplierDownloadFlag, setTailSupplierDownloadFlag] =
		useState<any>(false);

	const topSuppliersList = data.filter((d: any) => d.isTopSupplier);
	let topSuppliersListExport = JSON.parse(JSON.stringify(topSuppliersList));
	topSuppliersListExport.map((item: any, index: any) => {
		item.grossMargin = `${(item.grossMargin * 100).toFixed(2)}%`;
		return item;
	});

	const tailSuppliersList = data.filter((d: any) => !d.isTopSupplier);
	let tailSuppliersListExport = JSON.parse(JSON.stringify(tailSuppliersList));
	tailSuppliersListExport.map((item: any, index: any) => {
		item.grossMargin = `${(item.grossMargin * 100).toFixed(2)}%`;
		return item;
	});

	const handleButtonClick = (item: any) => {
		props.handleButtonClick(item);
	};

	const handleFilterUpdate = (value: any, filter: any) => {
		if (filter == "district") {
			updateSelectedDistrictFilter(value);
		}
	};

	const handleCheckAll = () => {
		if (tailSuppliersList.length === selectedTailSupplierList.length) {
			setSelectedTailSupplierList([]);
		} else {
			setSelectedTailSupplierList(
				tailSuppliersList.map((obj: any) => obj.master_vendor_name)
			);
		}
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	const { topSuppliers, tailSuppliers } = data.reduce(
		(initial: any, current: any) => {
			if (current.isTopSupplier) {
				return {
					...initial,
					topSuppliers: {
						spend: initial.topSuppliers.spend + current.spend,
						niaEarnings:
							initial.topSuppliers.niaEarnings +
							current.niaEarnings,
						grossMargin:
							initial.topSuppliers.grossMargin +
							current.grossMargin * current.spend,
					},
				};
			} else {
				return {
					...initial,
					tailSuppliers: {
						spend: initial.tailSuppliers.spend + current.spend,
						niaEarnings:
							initial.tailSuppliers.niaEarnings +
							current.niaEarnings,
						grossMargin:
							initial.tailSuppliers.grossMargin +
							current.grossMargin * current.spend,
					},
				};
			}
		},
		{
			topSuppliers: { spend: 0, niaEarnings: 0, grossMargin: 0 },
			tailSuppliers: { spend: 0, niaEarnings: 0, grossMargin: 0 },
		}
	);

	useEffect(() => {
		if (exportIntoStock?.length > 0) {
			exportIntoStockRef.current.link.click();
			setExportIntoStoc([]);
		}
	}, [exportIntoStock]);

	useEffect(() => {
		if (exportSPA?.length > 0) {
			exportSPARef.current.link.click();
			setExportSPA([]);
		}
	}, [exportSPA]);

	useEffect(() => {
		if (exportIntoStockSaving?.length > 0) {
			exportIntoStockSavingRef.current.link.click();
			setExportIntoStocSaving([]);
		}
	}, [exportIntoStockSaving]);

	useEffect(() => {
		if (exportSPASaving?.length > 0) {
			exportSPASavingRef.current.link.click();
			setExportSPASaving([]);
		}
	}, [exportSPASaving]);

	useEffect(() => {
		if (exportTailSupplier?.length > 0) {
			exportTailSupplierRef?.current?.link?.click();
			setExportTailSupplier([]);
		}
	}, [exportTailSupplier]);

	const handleGetIntoStockExportData = async () => {
		toaster.push(message, { placement: "topCenter" });
		let payload = {
			master_vendor_name: [selectedSupplier],
			district: selectedDistrictFilter ? [selectedDistrictFilter] : [],
			timeline: selectedTimeline ? [selectedTimeline] : [],
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			projectType: selectedProjectType,
			saving: page == "savingModel" ? true : false,
		};
		let res = await dispatch(getIntoStockExportData(payload));
		let temp: any = [];
		if (page == "savingModel") {
			setExportIntoStocSaving(res);
		} else {
			setExportIntoStoc(res);
		}

		// setIsLoading(false);
	};

	const handleGetSpaExportData = async () => {
		toaster.push(message, { placement: "topCenter" });
		let payload = {
			master_vendor_name: [selectedSupplier],
			district: selectedDistrictFilter ? [selectedDistrictFilter] : [],
			timeline: selectedTimeline ? [selectedTimeline] : [],
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			projectType: selectedProjectType,
			saving: page == "savingModel" ? true : false,
		};
		let res = await dispatch(getSpaExportData(payload));
		let temp: any = [];
		if (page == "savingModel") {
			setExportSPASaving(res);
		} else {
			setExportSPA(res);
		}
		// setIsLoading(false);
	};

	const handleGetTailExportData = async () => {
		toaster.push(message, { placement: "topCenter" });
		let payload = {
			master_vendor_name: selectedTailSupplierList,
			district: selectedDistrictFilter ? [selectedDistrictFilter] : [],
			timeline: selectedTimeline ? [selectedTimeline] : [],
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			projectType: selectedProjectType,
		};
		let res = await dispatch(getTailExportData(payload));
		let temp: any = [];
		if (page == "savingModel") {
			setExportTailSupplier(temp);
		} else {
			setExportTailSupplier(res);
		}
		// setIsLoading(false);
	};

	topSuppliers.grossMargin =
		(topSuppliers.grossMargin / topSuppliers.spend) * 100;
	tailSuppliers.grossMargin =
		(tailSuppliers.grossMargin / tailSuppliers.spend) * 100;

	return (
		<>
			<Modal
				onClose={() => setSelectedSupplier(null)}
				backdrop={true}
				role="alertdialog"
				open={proposalModal}
				size="xs"
				className="supplierConsolidationModal"
			>
				{!tailSupplierDownloadFlag ? (
					<Modal.Body>
						<Modal.Header closeButton={false}>
							<div className="flex">
								<div className="w-full"></div>
								<div className="text-center text-[2.5vh] w-full mb-[3vh]">
									{selectedSupplier} Proposal
								</div>
								<div className="w-full flex justify-end">
									<Button
										onClick={() => {
											setProposalModal(false);
											updateSelectedDistrictFilter(null);
										}}
										style={{ background: "#941c14" }}
										className="modal-close-btn  h-[4vh]"
									>
										Close
									</Button>
								</div>
							</div>
						</Modal.Header>

						<div className="flex justify-center gap-x-[2vh]">
							<div
								className="sub-heading-text"
								style={{ maxWidth: "7vw" }}
							>
								<span className="capitalize">District</span>
								<SelectPicker
									className="w-[100%]"
									data={
										districtfilterOptions["district"].length
											? districtfilterOptions["district"]
											: []
									}
									placeholder="All"
									labelKey={"district"}
									valueKey={"district"}
									value={
										selectedDistrictFilter
											? selectedDistrictFilter
											: []
									}
									onChange={(value: any) => {
										handleFilterUpdate(value, "district");
									}}
									cleanable={false}
								/>
							</div>
							<div
								className="sub-heading-text"
								style={{ maxWidth: "7vw" }}
							>
								<span className="capitalize">Timeline</span>
								<SelectPicker
									className="w-[100%]"
									data={
										timelineOptions.length
											? timelineOptions
											: []
									}
									placeholder="All"
									value={selectedTimeline}
									defaultValue={
										timelineOptions.length
											? timelineOptions[0].value
											: ""
									}
									onChange={timelineHandler}
									cleanable={false}
								/>
							</div>
						</div>

						<div className="flex justify-center">
							<div>
								<div className="flex justify-between items-center">
									<p className="mt-5">
										{page === "savingModel"
											? "Into Stock Cost Data"
											: "Into Stock Cost Proposal"}
									</p>
									<CSVLink
										data={exportIntoStock}
										headers={exportIntoStockHeader}
										filename="intostock.csv"
										className="hidden"
										target="_blank"
										ref={exportIntoStockRef}
									>
										{" "}
									</CSVLink>

									<CSVLink
										data={exportIntoStockSaving}
										headers={exportIntoStockSavingHeader}
										filename="intostock_saving.csv"
										className="hidden"
										target="_blank"
										ref={exportIntoStockSavingRef}
									>
										{" "}
									</CSVLink>
									<button
										className="ml-10 mt-5 text-white bg-[darkgreen] py-2 px-3 rounded-lg"
										onClick={handleGetIntoStockExportData}
									>
										{page === "savingModel"
											? "Download Data"
											: "Download Proposal"}
									</button>
								</div>
								<div className="flex justify-between items-center">
									<p className="mt-5">
										{page === "savingModel"
											? "SPA Data"
											: "SPA Proposal"}
									</p>
									<CSVLink
										data={exportSPA}
										headers={exportSPAHeader}
										filename="supplier_spa.csv"
										className="hidden"
										target="_blank"
										ref={exportSPARef}
									>
										{" "}
									</CSVLink>
									<CSVLink
										data={exportSPASaving}
										headers={exportSPASavingHeader}
										filename="supplier_spa_saving.csv"
										className="hidden"
										target="_blank"
										ref={exportSPASavingRef}
									>
										{" "}
									</CSVLink>
									<button
										className="ml-10 mt-5 text-white bg-[darkgreen] py-2 px-3 rounded-lg"
										onClick={handleGetSpaExportData}
									>
										{page === "savingModel"
											? "Download Data"
											: "Download Proposal"}
									</button>
								</div>
								{proposalSupplierType == "top" && (
									<div className="flex justify-between items-center">
										<p className="mt-5">
											{page === "savingModel"
												? "Tail Supplier Data"
												: "Tail Supplier Proposal"}
										</p>
										<button
											className="ml-10 mt-5 text-white bg-[darkgreen] py-2 px-3 rounded-lg"
											onClick={() => {
												setTailSupplierDownloadFlag(
													true
												),
													setSelectedTailSupplierList(
														tailSuppliersList.map(
															(obj: any) =>
																obj.master_vendor_name
														)
													);
											}}
										>
											{"Select Supplier"}
										</button>
									</div>
								)}
							</div>
						</div>
					</Modal.Body>
				) : (
					<Modal.Body>
						<Modal.Header closeButton={false}>
							<div className="flex">
								<div className="w-full">
									<button
										onClick={() => {
											setTailSupplierDownloadFlag(false);
										}}
										className=" bg-[darkgreen] text-white py-1 px-3 rounded-lg"
									>
										Back
									</button>
									<CSVLink
										data={exportTailSupplier}
										headers={exportTailSupplierHeader}
										filename="tail_supplier.csv"
										className="hidden"
										target="_blank"
										ref={exportTailSupplierRef}
									>
										{" "}
									</CSVLink>
									<button
										onClick={() => {
											handleGetTailExportData();
										}}
										className=" bg-[darkgreen] text-white  py-1 px-3 rounded-lg ml-3"
									>
										{page === "savingModel"
											? "Download Data"
											: "Download Proposal"}
									</button>
								</div>
								<div className="text-center text-[2.5vh] w-full mb-[3vh]">
									Tail End Suppliers for {props.l3}
								</div>
								<div className="w-full flex justify-end">
									<Button
										onClick={() => {
											setProposalModal(false);
											updateSelectedDistrictFilter(null);
											setTailSupplierDownloadFlag(false);
										}}
										style={{ background: "#941c14" }}
										className="modal-close-btn  h-[4vh]"
									>
										Close
									</Button>
								</div>
							</div>
						</Modal.Header>

						<div className="w-full flex flex-col items-center justify-center h-[50vh]">
							<div className="max-h-full w-[50%] flex justify-center overflow-y-auto">
								<table className="w-full common-table-ui">
									<thead>
										<tr>
											<th>Suppliers</th>
											<th  className="w-[40%]">
												{" "}
												Check all
												<Checkbox
													indeterminate={
														selectedTailSupplierList.length >
															0 &&
														selectedTailSupplierList.length <
															tailSuppliersList.length
													}
													checked={
														selectedTailSupplierList.length ===
														tailSuppliersList.length
													}
													onChange={() =>
														handleCheckAll()
													}
												></Checkbox>
											</th>
										</tr>
									</thead>
									<tbody>
										{tailSuppliersList.map((item: any) => {
											return (
												<tr>
													<td>
														{
															item.master_vendor_name
														}
													</td>
													<td className="flex justify-center">
														<CheckboxGroup
															name="checkbox-group"
															value={
																selectedTailSupplierList
															}
															onChange={(
																value: any
															) => {
																setSelectedTailSupplierList(
																	value
																);
															}}
														>
															<Checkbox
																value={
																	item.master_vendor_name
																}
															></Checkbox>
														</CheckboxGroup>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
							<span className="text-[1.7vh] w-[50%] pt-[1.5vh] text-[rgb(128,172,69)]">
								{" "}
								Please check supplier list before downloading
								the Proposal{" "}
							</span>
						</div>
					</Modal.Body>
				)}
			</Modal>

			<div className="suppliers-container contentBox flex flex-col gap-y-[2vh]">
				{props.tableLoading ? (
					<div className="loaderCustom"></div>
				) : props.l3.length > 0 ? (
					<>
						<div className="common-table-header-row">
							<div className="common-table-header">
								{topSuppliersList.length > 0 &&
									`Top Suppliers for ${props.l3}`}
							</div>
							{page !== "proposalLevel" &&
								page !== "savingModel" && (
									<CSVLink
										data={topSuppliersListExport}
										headers={csvHeaders}
										filename="top_suppliers.csv"
										target="_blank"
									>
										<FileDownloadIcon
											color="black"
											className="text-fsre15"
										/>
									</CSVLink>
								)}
						</div>

						{topSuppliersList.length > 0 ? (
							<>
								<div className="max-h-full overflow-y-auto">
									<table className="common-table-ui">
										<thead>
											<tr>
												<th className="w-[35%]">
													Supplier
												</th>
												<th className="w-[10%]">
													Spend ($)
												</th>
												<th className="w-[9%]">
													NIA ($)
												</th>
												<th className="w-[13%]">
													Gross Margin %
												</th>
												<th className="w-[25%]">
													Action
												</th>
											</tr>
										</thead>
										<tbody>
											{topSuppliersList.map(
												(d: any, index: any) => {
													return (
														<tr
															key={
																d.master_vendor_name
															}
														>
															<td>
																{
																	d.master_vendor_name
																}
															</td>
															<td>
																{numberFormatter(
																	d.spend,
																	0,
																	"$"
																)}
															</td>
															<td>
																{numberFormatter(
																	d.niaEarnings,
																	0,
																	"$"
																)}
															</td>
															<td>
																{(
																	d.grossMargin *
																	100
																).toFixed(
																	2
																)}{" "}
																%
															</td>
															<td className="flex justify-center">
																<button
																	className="savingButton"
																	onClick={() => {
																		if (
																			page !==
																				"proposalLevel" &&
																			page !==
																				"savingModel"
																		) {
																			props.shiftSuppliers(
																				d
																			);
																			props.updateButtonEnabled(
																				true
																			);
																		} else {
																			setSelectedSupplier(
																				d.master_vendor_name
																			);
																			setProposalModal(
																				true
																			);
																			setProposalSupplierType(
																				"top"
																			);
																			handleButtonClick(
																				d.master_vendor_name
																			);
																		}
																	}}
																>
																	{page !==
																		"proposalLevel" &&
																	page !==
																		"savingModel"
																		? "Move to Tail"
																		: page ===
																		  "savingModel"
																		? "Download Data"
																		: "Download Proposal"}
																</button>
															</td>
														</tr>
													);
												}
											)}
											<tr className="total-row">
												<td className="center">
													Total
												</td>
												<td>
													{numberFormatter(
														topSuppliers.spend,
														0,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														topSuppliers.niaEarnings,
														0,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														topSuppliers.grossMargin,
														2
													)}{" "}
													%
												</td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
							</>
						) : (
							<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
								No Top Suppliers for {props.l3} category
							</div>
						)}
					</>
				) : (
					<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
						Please select the L3 Category to see the relevant Top
						spend suppliers
					</div>
				)}
			</div>
			<div className="suppliers-container contentBox flex flex-col gap-y-[2vh]">
				{props.tableLoading ? (
					<div className="loaderCustom"></div>
				) : props.l3.length > 0 ? (
					<>
						<div className="common-table-header-row">
							<div className="common-table-header">
								{tailSuppliersList.length > 0 &&
									`Tail End Suppliers for ${props.l3}`}
							</div>
							{page !== "proposalLevel" &&
								page !== "savingModel" && (
									<CSVLink
										data={tailSuppliersListExport}
										headers={csvHeaders}
										filename="tail_suppliers.csv"
										target="_blank"
									>
										<FileDownloadIcon
											color="black"
											className="text-fsre15"
										/>
									</CSVLink>
								)}
						</div>
						{tailSuppliersList.length > 0 ? (
							<>
								<div className="max-h-full overflow-y-auto">
									<table className="common-table-ui">
										<thead>
											<tr>
												<th className="w-[35%]">
													Supplier
												</th>
												<th className="w-[10%]">
													Spend ($)
												</th>
												<th className="w-[9%]">
													NIA ($)
												</th>
												<th className="w-[13%]">
													Gross Margin %
												</th>
												<th className="w-[25%]">
													Action
												</th>
											</tr>
										</thead>
										<tbody>
											{tailSuppliersList.map(
												(d: any, index: any) => {
													return (
														<tr
															key={
																d.master_vendor_name
															}
														>
															<td>
																{
																	d.master_vendor_name
																}
															</td>
															<td>
																{numberFormatter(
																	d.spend,
																	0,
																	"$"
																)}
															</td>
															<td>
																{numberFormatter(
																	d.niaEarnings,
																	0,
																	"$"
																)}
															</td>
															<td>
																{(
																	d.grossMargin *
																	100
																).toFixed(
																	2
																)}{" "}
																%
															</td>
															<td className="flex justify-center">
																<button
																	className="savingButton"
																	onClick={() => {
																		if (
																			page !==
																				"proposalLevel" &&
																			page !==
																				"savingModel"
																		) {
																			props.shiftSuppliers(
																				d
																			);
																			props.updateButtonEnabled(
																				true
																			);
																		} else {
																			setSelectedSupplier(
																				d.master_vendor_name
																			);
																			setProposalModal(
																				true
																			);
																			setProposalSupplierType(
																				"tail"
																			);
																			handleButtonClick(
																				d.master_vendor_name
																			);
																		}
																	}}
																>
																	{page !==
																		"proposalLevel" &&
																	page !==
																		"savingModel"
																		? "Move to Top"
																		: page ===
																		  "savingModel"
																		? "Download Data"
																		: "Download Proposal"}
																</button>
															</td>
														</tr>
													);
												}
											)}
											<tr className="total-row">
												<td className="center">
													Total
												</td>
												<td>
													{numberFormatter(
														tailSuppliers.spend,
														0,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														tailSuppliers.niaEarnings,
														0,
														"$"
													)}
												</td>
												<td>
													{numberFormatter(
														tailSuppliers.grossMargin,
														2
													)}{" "}
													%
												</td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
							</>
						) : (
							<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
								No Tail End Suppliers for {props.l3} category
							</div>
						)}
					</>
				) : (
					<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
						Please select the L3 Category to see the relevant Tail
						end suppliers
					</div>
				)}
			</div>
		</>
	);
};

const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be download automatically</p>
	</Notification>
);

export default CategoryOverview;
